export function withNotification(fn, { successTitle, successMessage, errorTitle, fallbackErrorMessage }) {
  return async function (...args) {
    try {
      const result = await fn(...args);
      window.$notify(successTitle || 'Success', successMessage || '', 'success');
      return result;
    } catch (error) {
      const message = error?.message || fallbackErrorMessage || 'Something went wrong';
      window.$notify(errorTitle || 'Error', message, 'error');
    }
  };
}